import React, {useState} from 'react';
import {makeStyles} from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import {LeyendaItem, LeyendaProps} from './LeyendaItemListTypes';
import {PtrnPropsUtil} from '../../patronUtils';
import {colorNameToColorObj} from '../../colorUtils';
import {PaletteColor} from '@mui/material';
import LightTooltip from '../../../atomicos/LightTooltip';

const useStyles = makeStyles<LeyendaItem[]>()((theme, items) => {
   return {
      valueButton: {
         whiteSpace: 'pre',
         borderRadius: 4
      }
   };
});

function LeyendaItemList({items, value, tooltips, ...other}: LeyendaProps) {
   const {classes, theme} = useStyles(items);
   const idCompPrefix = 'leili';

   const [selectedLeyend, setselectedLeyend] = useState(-1);
   function limpiar() {
      setselectedLeyend(-1);
   }
   function handleOnLeyendClick(
      item: LeyendaItem,
      index: number,
      currentSelected: number | string
   ) {
      let parsedCurrentSelected = -1;
      try {
         //intentar parsear la cadena de la leyenda actual seleccionada en caso se pase algun valor no valido
         parsedCurrentSelected = parseInt(currentSelected.toString());
      } finally {
         const esElegido = currentSelected === index;
         if (esElegido) {
            limpiar();
         } else {
            setselectedLeyend(index);
         }
         if (item.onClick) {
            item.onClick(item, currentSelected === index);
         }
      }
   }

   function generateToggleButtonStyle(colorObj: PaletteColor) {
      return {
         borderRadius: 4,
         borderWidth: 2,
         padding: '4px',
         borderColor: colorObj.dark,
         backgroundColor: 'white',
         color: 'black',
         transition: 'background-color 0.3s, border 0.3s',
         '&:hover': {
            backgroundColor: colorObj.main,
            color: 'white'
         },
         '&.Mui-selected': {
            backgroundColor: colorObj.light,
            color: 'black',
            '&:hover': {
               backgroundColor: colorObj.main,
               color: colorObj.contrastText
            }
         }
      };
   }

   return (
      <Grid id={`${idCompPrefix}-grid`} {...other} container spacing={1}>
         {items.map((curr, inx) => {
            function handleItemClick() {
               handleOnLeyendClick(curr, inx, selectedLeyend);
            }

            const colorObj = colorNameToColorObj(curr.color, theme);
            const toggleButtonStyle = generateToggleButtonStyle(colorObj);
            const xs = curr.xs && curr.xs > 0 && curr.xs < 13 ? curr.xs : 3;

            let leyendItemValue = curr.noValue || '0';
            if (value && value[curr.label] != null) {
               leyendItemValue = value[curr.label];
            }
            const CurrentTooltipTitle = tooltips && tooltips[curr.label];
            const CurrentToggleButton = (
               <ToggleButton
                  value={inx}
                  title={!CurrentTooltipTitle && curr.label}
                  style={{borderRadius: 4}}
                  sx={toggleButtonStyle}
                  //@ts-ignore
                  color={PtrnPropsUtil.getPropValue(curr.color)}
               >
                  {leyendItemValue}
               </ToggleButton>
            );
            return (
               <Grid key={inx} id={`${idCompPrefix}-grid-${inx}`} container item xs={xs}>
                  <ToggleButtonGroup
                     color="primary"
                     value={selectedLeyend}
                     exclusive
                     onChange={handleItemClick}
                     aria-label="Platform"
                     size="small"
                  >
                     {CurrentTooltipTitle && (
                        <LightTooltip
                           title={CurrentTooltipTitle}
                           componentsProps={{
                              tooltip: {
                                 sx: {backgroundColor: colorObj.main, color: colorObj.contrastText}
                              },
                              arrow: {sx: {color: colorObj.main}}
                           }}
                           placement="top"
                           arrow
                        >
                           {CurrentToggleButton}
                        </LightTooltip>
                     )}
                     {!CurrentTooltipTitle && CurrentToggleButton}
                     {!curr.noLabel && (
                        <ToggleButton
                           value={inx}
                           title={curr.label}
                           style={{
                              border: '0px',
                              whiteSpace: ' nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                           }}
                           //@ts-ignore
                           color={PtrnPropsUtil.getPropValue(curr.color)}
                        >
                           {curr.label}
                        </ToggleButton>
                     )}
                  </ToggleButtonGroup>
               </Grid>
            );
         })}
      </Grid>
   );
}

export default LeyendaItemList;
